var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 147.4 147.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,26.26a47.2,47.2,0,0,0-35.77,78v16.48l11.9-6.55A47.21,47.21,0,1,0,50,26.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97,26.26a47.19,47.19,0,0,1,35.76,78v16.48l-11.89-6.55A47.21,47.21,0,1,1,97,26.26Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue1);
export default __webpack_public_path__ + "static/media/value_1.0f68af5242eafec153e12c73a23723ea.svg";
export { ForwardRef as ReactComponent };